import React from 'react';
import { motion } from 'framer-motion';
export function PainAgitation() {
  return <section className="w-full py-16 md:py-24 bg-[#F4F1E1]/80" data-id="element-143">
      <motion.div className="max-w-3xl mx-auto px-6" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-144">
        <h2 className="font-lora text-3xl md:text-4xl font-bold text-charcoal mb-8" data-id="element-145">
          ¿Conoces esa sensación de estar completamente rodeado de gente y
          sentirte completamente solo con tu propio pánico?
        </h2>

        <div className="font-inter text-lg text-charcoal/90 leading-relaxed space-y-6" data-id="element-146">
          <p data-id="element-147">
            Estás en una reunión. Tu jefe habla. Alguien hace una pregunta. Y de
            repente, tu mente ya no está ahí. Está en otro lugar, calculando
            cuánto tardaría en salir si lo necesitas, midiendo si tu respiración
            suena rara, preguntándose si alguien nota que estás sudando aunque
            hace frío.
          </p>

          <p data-id="element-148">
            O estás con tu familia en la cena y, en lugar de estar presente,
            estás monitoreando tu propio cuerpo como si fueras un técnico
            buscando una falla. Latido. Respiración. Tensión en los hombros. ¿Es
            normal este mareo?
          </p>

          <p className="font-semibold text-sage" data-id="element-149">
            La ansiedad no solo te roba los momentos malos. Te roba los buenos
            también.
          </p>

          <div className="mt-12 pt-8 border-t border-charcoal/10" data-id="element-150">
            <h3 className="font-lora text-2xl font-bold text-charcoal mb-6" data-id="element-151">
              Y lo más cruel de todo es que ya sabes que "no es para tanto"
            </h3>

            <p data-id="element-152">
              Ya te lo has dicho a ti mismo mil veces. Y sin embargo, el cuerpo
              no escucha razones.
            </p>

            <p data-id="element-153">
              Has googleado los síntomas a las 11 de la noche y has terminado
              convencido de que tenías algo grave. Has cancelado planes porque
              "no te sentías bien" aunque no podías explicar exactamente qué
              tenías. Has sonreído en fotos mientras por dentro sentías que el
              suelo se movía bajo tus pies.
            </p>

            <p className="font-semibold" data-id="element-154">
              Y lo más agotador no es la ansiedad en sí. Es el esfuerzo
              constante de ocultarla. De funcionar. De parecer normal cuando por
              dentro sientes que algo está roto.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}